import { RequestService } from '../../../../common/services/RequestService';
import { UPLOAD_PHOTO_CUSTOMER } from '../constants';

export const uploadCustomerPhoto = payload => {
  return RequestService.post(UPLOAD_PHOTO_CUSTOMER, JSON.stringify(payload));
};
